import { createContext } from 'react';

export const LimitationsContext = createContext();